(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["casket-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('in-memory-personalization')) {
    customElements.define(
      'in-memory-personalization',
      class InMemoryPersonalization extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('.imc-personalization');
          if (!this.panel) return;

          this.form = document.getElementById(this.panel.dataset.formId);
          this.scope = this.closest('product-component') || this.form?.closest('product-component') || this.parentElement;
          this.handleChange = this.handleChange.bind(this);
          this.handleInput = this.handleInput.bind(this);
          this.scope.addEventListener('change', this.handleChange);
          this.scope.addEventListener('input', this.handleInput);

          this.observer = new MutationObserver(() => this.queueSync());
          this.observer.observe(this.scope, { childList: true, subtree: true });
          this.sync();
        }

        disconnectedCallback() {
          this.scope?.removeEventListener('change', this.handleChange);
          this.scope?.removeEventListener('input', this.handleInput);
          this.observer?.disconnect();
          if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        }

        handleChange(event) {
          const target = event.target;
          if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

          if (target.matches('[data-personalization-photo-input]')) {
            this.updatePhotoPreview(target);
          }

          if (target.matches('[data-personalization-font-input]')) {
            this.updateNamePreview();
          }

          const optionName =
            target.dataset.optionName ||
            target.name?.match(/^options\[(.+)\]$/)?.[1] ||
            '';

          if (optionName.toLowerCase() === 'personalization') {
            this.sync(target.value);
          }
        }

        handleInput(event) {
          const target = event.target;
          if (target instanceof HTMLInputElement && target.matches('[data-personalization-name-input]')) {
            this.updateNamePreview();
          }
        }

        queueSync() {
          if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
          this.animationFrame = requestAnimationFrame(() => this.sync());
        }

        getSelectedValue() {
          const selectedRadio = Array.from(
            this.scope.querySelectorAll('input[data-option-name]:checked')
          ).find((input) => input.dataset.optionName?.toLowerCase() === 'personalization');

          if (selectedRadio) return selectedRadio.value;

          const selectedDropdown = Array.from(this.scope.querySelectorAll('select')).find(
            (select) => select.name?.toLowerCase() === 'options[personalization]'
          );

          return selectedDropdown?.value || this.panel.dataset.initialSelection || '';
        }

        sync(explicitValue) {
          const value = (explicitValue || this.getSelectedValue()).toLowerCase();
          const needsName = value.includes('name');
          const needsPhoto = value.includes('photo');

          this.toggleField('[data-personalization-name]', needsName);
          this.toggleField('[data-personalization-font]', needsName);
          this.toggleField('[data-personalization-photo]', needsPhoto);
          this.toggleZone('[data-personalization-preview-name-zone]', needsName);
          this.toggleZone('[data-personalization-preview-photo-zone]', needsPhoto);
          this.toggleZone('[data-personalization-strip-map]', needsName);
          this.toggleField('[data-personalization-proof]', needsName || needsPhoto);

          const preview = this.querySelector('[data-personalization-preview]');
          if (preview) preview.hidden = !(needsName || needsPhoto);

          if (needsName || needsPhoto) this.panel.open = true;

          this.form = document.getElementById(this.panel.dataset.formId) || this.form;
          if (this.form) {
            this.form.enctype = 'multipart/form-data';
            this.form.encoding = 'multipart/form-data';
          }

          this.scope.querySelectorAll('.shopify-payment-button').forEach((button) => {
            button.hidden = true;
          });

          this.updateNamePreview();
        }

        toggleField(selector, enabled) {
          const field = this.querySelector(selector);
          if (!field) return;

          field.hidden = !enabled;
          if (field instanceof HTMLFieldSetElement) field.disabled = !enabled;

          field.querySelectorAll('input, select, textarea').forEach((control) => {
            const requiredWhenEnabled = control.hasAttribute('data-required-when-enabled');
            control.disabled = !enabled;
            control.required = enabled && requiredWhenEnabled;
            control.setAttribute('aria-required', enabled && requiredWhenEnabled ? 'true' : 'false');
            if (!enabled) control.setCustomValidity('');
          });
        }

        toggleZone(selector, enabled) {
          const zone = this.querySelector(selector);
          if (zone) zone.hidden = !enabled;
        }

        updateNamePreview() {
          const input = this.querySelector('[data-personalization-name-input]');
          const previews = this.querySelectorAll('[data-personalization-preview-name]');
          if (!input || previews.length === 0) return;

          const selectedFont = this.querySelector('[data-personalization-font-input]:checked');
          previews.forEach((preview) => {
            preview.textContent = input.value.trim() || preview.dataset.emptyLabel || '';
            preview.dataset.fontStyle = selectedFont?.dataset.previewFont || 'classic';
          });
        }

        updatePhotoPreview(input) {
          const zone = this.querySelector('[data-personalization-preview-photo-zone]');
          const placeholder = this.querySelector('[data-personalization-preview-photo-placeholder]');
          const status = this.querySelector('[data-personalization-photo-status]');
          if (!zone || !placeholder || !status) return;

          const file = input.files?.[0];

          if (!file) {
            delete zone.dataset.photoReady;
            placeholder.textContent = placeholder.dataset.emptyLabel || '';
            status.hidden = true;
            status.textContent = '';
            return;
          }

          const selectedLabel = this.querySelector('[data-personalization-preview]')?.dataset.photoSelectedLabel || '';
          status.textContent = `${selectedLabel} ${file.name}`.trim();
          status.hidden = false;
          zone.dataset.photoReady = 'true';
          placeholder.textContent = placeholder.dataset.emptyLabel || '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["memorial-board-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('memorial-addon-form')) {
    customElements.define(
      'memorial-addon-form',
      class MemorialAddonForm extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const headingInput = this.querySelector('[data-memorial-heading]');
          const headingPreview = this.querySelector('[data-template-heading]');
          if (headingInput && headingPreview) {
            const updateHeading = () => {
              headingPreview.textContent = headingInput.options[headingInput.selectedIndex].text;
            };
            headingInput.addEventListener('change', updateHeading);
            updateHeading();
          }

          this.querySelectorAll('[data-memorial-file]').forEach((input) => {
            input.addEventListener('change', () => {
              const status = input.parentElement.querySelector('[data-file-status]');
              if (!status) return;
              status.textContent = input.files && input.files[0]
                ? 'Selected: ' + input.files[0].name
                : 'No photo selected.';
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["memorial-matching-links"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('memorial-matching-links'))customElements.define('memorial-matching-links',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const link=event.target.closest('a');if(!link)return;const scope=this.closest('.shopify-section');const id=scope?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;if(id){const url=new URL(link.href);url.searchParams.set('wrap_variant',id);link.href=url.href;}});}
  });
  } catch(e) { console.error(e); }
})();

})();
